import './Preloader.css';

export const Preloader = () => {
    return (
        <div className="preloader" />
    );
};